import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import { getIntegrationDefinition } from '@next-adapter/integration-registry.js'
import { normalizeInstalledIntegrations } from './normalize-installed-integrations.js'

export function getActiveEmailProvider(config: ResolvedBetterstartConfig) {
  return normalizeInstalledIntegrations(config)
    .map((integrationId) => getIntegrationDefinition(integrationId))
    .map((definition) => definition.capabilities?.emailProvider)
    .find((provider) => provider?.provider === config.email.provider)
}
